<template>
    <information-popup modal-id="inscriptionExamplesPopup">
        <template slot="header">Inscription Examples</template>
        <slot>
            <div class="modal-body inscription-modal">
                <div class="row">
                    <div class="col-sm-3">
                        <h3 class="text-danger">INSPIRING</h3>
                        <p><strong>4x8</strong></p>
                        <p>A SOLID FUTURE</p>
                        <p>FOR THE KIDS</p>
                        <p>OF CALDWELL! KS</p>
                    </div>
                    <div class="col-sm-3">
                        <h3 class="text-danger">FAMILY</h3>
                        <p><strong>4x8</strong></p>
                        <p>OUR ROOTS ARE</p>
                        <p>HERE IN CALDWELL</p>
                        <p>THE JONES FAM</p>
                    </div>
                    <div class="col-sm-3">
                        <h3 class="text-danger">TEAM</h3>
                        <p><strong>4x8</strong></p>
                        <p>#YOTE FAM</p>
                        <p>STOMPING GROUND</p>
                        <p>GO PURPLE & GOLD</p>
                    </div>
                    <div class="col-sm-3">
                        <h3 class="text-danger">REMEMBRANCE</h3>
                        <p><strong>4x8</strong></p>
                        <p>IN HONOR OF</p>
                        <p>BRIAN ARMSTRONG</p>
                        <p>1965-2009</p>
                    </div>
                </div>
                <hr/>
                <div class="row">
                    <div class="col-sm-3">
                        <h3 class="text-danger">ANNIVERSARY</h3>
                        <p><strong>4x8</strong></p>
                        <p>OUR LOVE GREW</p>
                        <p>IN CALDWELL 1965</p>
                        <p>JIM & MARY ROSS</p>
                    </div>
                    <div class="col-sm-3">
                        <h3 class="text-danger">FATHER'S DAY</h3>
                        <p><strong>4x8</strong></p>
                        <p>DANNY NEWMAN</p>
                        <p>NUMBER ONE DAD!</p>
                        <p>LOVE, YOUR SON</p>
                    </div>
                    <div class="col-sm-3">
                        <h3 class="text-danger">MOTHER'S DAY</h3>
                        <p><strong>4x8</strong></p>
                        <p>HAPPY MOTHER'S</p>
                        <p>DAY MOM!</p>
                        <p>JEN & DON BRADY</p>
                    </div>
                    <div class="col-sm-3">
                        <h3 class="text-danger">GENERAL</h3>
                        <p><strong>4x8</strong></p>
                        <p>CALDWELL, IDAHO</p>
                        <p>MY HOME & HEART</p>
                        <p>VAL HULL</p>
                    </div>
                </div>
            </div>
        </slot>
    </information-popup>
</template>

<script type="text/jsx">
    import InformationPopup from '@/components/popup/information-popup.vue';
    export default {
        name: 'inscription-examples',
        components: {
            'information-popup': InformationPopup
        }
    }
</script>

<style lang="scss" scoped>
    .inscription-modal {
        h3, p {
            white-space: nowrap;
        }
    }
</style>


// WEBPACK FOOTER //
// InscriptionExamples.vue?f2b051fe